import React from 'react'
import Modal from 'blocks.simple/modal/modal'
import Icon from 'blocks.simple/icon/icon'
import EditText from 'blocks.simple/editText/editText'
import Checkbox from 'blocks.simple/checkbox/checkbox'
import { Button } from '../../../molecules/Button'
import Dropdown from 'blocks.simple/dropdown/dropdown'
import HistoryFilterMethods from './history__filter.local.methods'
import { getFilterConfing } from './history__filter.config'
import { cn } from 'ethcss'
import styles from './history__filter.jcss'
import { text as textStyles, item, grid } from 'theme'
import translate from 'core/translate'
import { Typography } from 'atoms/Typography'
import { isEmpty } from 'lodash'
import { FilterButton } from 'molecules/FilterButton'

const HistoryFilter = (p_: any) => {
    const isFilterList = !isEmpty(p_.selected)

    const {
        openFilter,
        isFilterOpen,
        selectFilter,
        selectedFilter,
        _filterSearch,
        filterSearch,
        checkAll,
        filterFields,
        toggleField,
        startDate,
        endDate,
        closeFilter,
        onFilterChange,
        setStartDate,
        setEndDate,
        resetFilter,
        resetRequested,
    } = HistoryFilterMethods(p_)

    return (
        <div className={styles.filter}>
            <FilterButton active={isFilterOpen || isFilterList} onClick={openFilter} />
            {/*{isFilterList && (*/}
            {/*    <div className={cn(grid.fullWidth, grid.row, grid.center, item.abs)}>*/}
            {/*        <Icon type="arrowhead_up" color="white" size="40" />*/}
            {/*    </div>*/}
            {/*)}*/}
            <div className={item.abs}>
                <Modal open={isFilterOpen} showCloseIcon={false} mod={'clear'} transitionName={'fade'}>
                    <div className={styles.modalWrapper}>
                        <section
                            className={styles.modalInner}
                            role="dialog"
                            aria-modal="true"
                            aria-labelledby="history-filter-title"
                        >
                            <header className={styles.modalHeader}>
                                <div id="history-filter-title">
                                    <Typography type="title">{translate('filter')}</Typography>
                                </div>
                                <button
                                    type="button"
                                    className={styles.closeButton}
                                    aria-label={translate('close')}
                                    onClick={closeFilter}
                                >
                                    <Icon type="close_tiny" size={16} />
                                </button>
                            </header>

                            <div className={styles.modalBody}>
                                <div className={cn(textStyles.mini, grid.col, styles.mobileScroll)}>
                                    <div className={styles.selectorField}>
                                        <Dropdown
                                            placeholder={translate('filter')}
                                            options={getFilterConfing().filtersBy}
                                            onChange={selectFilter}
                                            value={selectedFilter ? selectedFilter.id : null}
                                        />
                                        {!selectedFilter && (
                                            <Typography type="text" className={cn(grid.pt_micro, textStyles.center)}>
                                                {translate('searchHistoryFilter')}
                                            </Typography>
                                        )}
                                    </div>
                                    {selectedFilter && selectedFilter.id !== 'date' && (
                                        <div className={cn(grid.col, grid.space, styles.mobileScroll)}>
                                            <div className={styles.fieldWrapper}>
                                                <EditText
                                                    icon={'search'}
                                                    value={_filterSearch}
                                                    onChange={filterSearch}
                                                />
                                            </div>
                                            <div className={cn(styles.fieldWrapper, grid.row, grid.justify)}>
                                                <div />
                                                <div className={grid.row}>
                                                    <div
                                                        className={cn(item.pointer, textStyles.underline, grid.mr_mini)}
                                                        onClick={() => checkAll(true)}
                                                    >
                                                        {translate('selectAll')}
                                                    </div>
                                                    <div
                                                        className={cn(item.pointer, textStyles.underline)}
                                                        onClick={() => checkAll(false)}
                                                    >
                                                        {translate('clear')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={cn(styles.filterFields)}>
                                                {filterFields
                                                    .filter((field: any) => {
                                                        return (
                                                            field.name
                                                                .toLowerCase()
                                                                .indexOf(_filterSearch.toLowerCase()) !== -1
                                                        )
                                                    })
                                                    .map((field, index) => (
                                                        <div key={`checkItem_${index}`} className={styles.checkItem}>
                                                            <Checkbox
                                                                onClick={() => toggleField(field.index)}
                                                                checked={field.checked}
                                                                label={field.name}
                                                            />
                                                        </div>
                                                    ))}
                                            </div>
                                        </div>
                                    )}
                                    {selectedFilter && selectedFilter.id === 'date' && (
                                        <div className={cn(grid.col, grid.space, grid.p_mini)}>
                                            <Checkbox
                                                checked={p_.byStartDateChecked}
                                                onClick={() => p_.setByStartDateChecked(!p_.byStartDateChecked)}
                                                label={translate('byStartDate')}
                                            />
                                            {p_.byStartDateChecked && (
                                                <div>
                                                    <EditText
                                                        containerClass={cn(grid.mt_md)}
                                                        type={'date'}
                                                        label={translate('startDate')}
                                                        dateValue={startDate}
                                                        onChange={(startDate: any) => setStartDate(startDate)}
                                                    />
                                                </div>
                                            )}
                                            <Checkbox
                                                checked={p_.byEndDateChecked}
                                                onClick={() => p_.setByEndDateChecked(!p_.byEndDateChecked)}
                                                label={translate('byEndDate')}
                                                wrapperClassName={cn(grid.mt_md, grid.mb_md)}
                                            />
                                            {p_.byEndDateChecked && (
                                                <div>
                                                    <EditText
                                                        containerClass={cn(styles.endDatePicker)}
                                                        type={'date'}
                                                        label={translate('endDate')}
                                                        dateValue={endDate}
                                                        onChange={(endDate: any) => setEndDate(endDate)}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>

                                <button type="button" className={styles.resetButton} onClick={resetFilter}>
                                    {translate('resetFilter')}
                                </button>
                            </div>
                            <footer className={styles.buttons}>
                                <Button className={cn(styles.actionButton)} onClick={closeFilter}>
                                    {translate('close')}
                                </Button>
                                <Button mod="fillBrand" className={cn(styles.actionButton)} onClick={onFilterChange}>
                                    {translate('apply')}
                                </Button>
                            </footer>
                        </section>
                    </div>
                </Modal>
            </div>
        </div>
    )
}

export default HistoryFilter
